export const DEFAULT_LANGUAGE = 'en'
export const FALLBACK_LANGUAGE = 'en'

export const AUTH_COOKIE_NAME = 'SinchAuthSession'
export const REMEMBER_ME_COOKIE_NAME = 'remember'

export const MEMBERSHIP_BUCKET_TYPE = 'Membership'
export const FREE_BUCKET_TYPE = 'Free'
export const TEST_BUCKET_TYPE = 'Test'
export const UNLIMITED_BUCKET_TYPE = 'Unlimited'
export const DEAL_BUCKET_TYPE = 'Deal'

export const MEMBERSHIP_PRODUCT_TYPE = 'membership'
export const REBIN_PRODUCT_TYPE = 'Rebin'
export const SIM_PRODUCT_TYPE = 'SimService'

export const GLOBAL_UNLIMITED_PRODUCT_CATEGORY_TYPE = 'Global Unlimited'
export const GLOBAL_LIMITED_PRODUCT_CATEGORY_TYPE = 'Global Limited'
export const UNLIMITED_PRODUCT_CATEGORY_TYPE = 'Unlimited'
export const LIMITED_PRODUCT_CATEGORY_TYPE = 'Limited'

export const USER_ACTIVITY_BATCH_SIZE = 50

export const LOW_BALANCE_AMOUNT = 2.5

export const FIVE_MINUTES_IN_SECONDS = 300
export const ONE_DAY_IN_SECONDS = 86400
export const THIRTY_DAYS_IN_SECONDS = 2592000

export const API_DEFAULT_TIMEOUT_MS = 30000

export const TIKTOK_CLICK_ID = 'ttclid'
export const TIKTOK_COOKIE_ID = '_ttp'

export const SUPPORTED_LANGUAGES_IN_NEW_CHECKOUT = ['ar', 'en', 'es', 'fa', 'fr']

export const SUPPORTED_CULTURES = [{
  'englishName': 'Arabic',
  'nativeName': 'العربية',
  'twoLetter': 'ar',
  'culture': 'ar-SA'
}, {
  'englishName': 'Chinese',
  'nativeName': '中文',
  'twoLetter': 'zh',
  'culture': 'zh-CN'
},
{
  'englishName': 'Dari',
  'nativeName': 'دری',
  'twoLetter': 'fa',
  'culture': 'fa-AF'
}, {
  'englishName': 'English',
  'nativeName': 'English',
  'twoLetter': 'en',
  'culture': 'en-US'
}, {
  'englishName': 'French',
  'nativeName': 'Français',
  'twoLetter': 'fr',
  'culture': 'fr-FR'
}, {
  'englishName': 'German',
  'nativeName': 'Deutsch',
  'twoLetter': 'de',
  'culture': 'de-DE'
}, {
  'englishName': 'Italian',
  'nativeName': 'Italiano',
  'twoLetter': 'it',
  'culture': 'it-IT'
}, {
  'englishName': 'Japanese',
  'nativeName': '日本語',
  'twoLetter': 'ja',
  'culture': 'ja-JP'
}, {
  'englishName': 'Polish',
  'nativeName': 'Polski',
  'twoLetter': 'pl',
  'culture': 'pl-PL'
}, {
  'englishName': 'Portuguese',
  'nativeName': 'Português',
  'twoLetter': 'pt',
  'culture': 'pt-BR'
}, {
  'englishName': 'Romanian',
  'nativeName': 'Română',
  'twoLetter': 'ro',
  'culture': 'ro-RO'
}, {
  'englishName': 'Spanish',
  'nativeName': 'Español',
  'twoLetter': 'es',
  'culture': 'es-ES'
}, {
  'englishName': 'Swedish',
  'nativeName': 'Svenska',
  'twoLetter': 'sv',
  'culture': 'sv-SE'
}, {
  'englishName': 'Turkish',
  'nativeName': 'Türkçe',
  'twoLetter': 'tr',
  'culture': 'tr-TR'
}]

export const HIDE_WELCOME_TOUR = 'hideWelcomeTour'
export const HIDE_WELCOME_OFFER = 'hideWelcomeOffer'
export const HIDE_CUBA_RECHARGE_BANNER = 'hideCubaRechargeBanner'

export const BUNDLE_PRODUCT_CATEGORY = 'MTU_PLANS_BUNDLES'
export const CREDIT_PRODUCT_CATEGORY = 'MTU_CREDITS'
export const MANDAO_PRODUCT_CATEGORY = 'FOOD_CREDITS'
export const PLAN_PRODUCT_CATEGORY = 'MTU_PLANS_BUNDLES_PLAN'
export const NAUTA_PRODUCT_SUB_CATEGORY = 'MTU_PLANS_BUNDLES_NAUTA'

export const CREDITS_MINUTES_SUB_CATEGORY = 'CALLING_WORLD_CREDITS_MINUTES'
export const CALLING_SUBSCRIPTION_UNLIMITED_SUB_CATEGORY = 'CALLING_SUBSCRIPTION_UNLIMITED'
export const CALLING_SUBSCRIPTION_LIMITED_SUB_CATEGORY = 'CALLING_SUBSCRIPTION_LIMITED'

export const SURVEY_MTU_CREDITS_SUB_CANCELLATION = 'MTU_Credit_Sub_Cancellation'
export const SURVEY_MTU_PLANS_SUB_CANCELLATION = 'MTU_Plan_Sub_Cancellation'
export const SURVEY_MTU_BUNDLES_SUB_CANCELLATION = 'MTU_Bundle_Sub_Cancellation'
export const DELIVERABLE_TYPE_DATA = 'DATA'
export const DELIVERABLE_TYPE_SMS = 'SMS'
export const DELIVERABLE_TYPE_MINUTES = 'MINUTES'
export const DELIVERABLE_TYPE_CREDITS = 'CREDITS'



// WEBPACK FOOTER //
// ./src/utils/constants.js